import { DatePicker } from 'antd'
import { useEffect, useState } from 'react'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import { getEmpsExcelLog2API } from '../../../services/employee'
import { useSelector } from 'react-redux'
import Error_false from '../../error/error-false'
import { Image, Table, Row, Col, Button } from 'react-bootstrap'
import ImgUser from '../../../images/user.png'
import SpinnerLoading from '../../spinner-loading'
import CardCustom from '../../custom/card-custom'
import NavTitle from '../../nav-title'
import TextNavTitle from '../../TextNavTitle'
import NavRoleOrg from '../../nav-role-org'
import excelImg from '../../../images/xlsFile.svg'
import { saveAs } from 'file-saver'
import SwalCustom from '../../../alert/swal-custom'
import { getReportBirthdayAPI } from '../../../services/report'
import dayjs from 'dayjs'
import { fnDateEn } from '../../../helper/fnDateEn'
import { fnDateTh } from '../../../helper/fnDateTh'
import { createSpreadsheetBlob } from '../../../helper/spreadsheet/write-spreadsheet'
import { buildBirthdayReportSheet } from '../../../helper/spreadsheet/monthly-employee-reports'

function ReportBirthdayPage() {
  const roleId = useSelector((state) => state.roleReducer.role)
  const [page, setPage] = useState(1)
  const [dataEmps, setDataEmps] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [totalRows, setTotalRows] = useState(0)
  const [totalLimits, setTotalLimits] = useState(20)
  const dateFormat = 'MMMM YYYY'
  const [isExport, setIsExport] = useState(false)
  const toDay = dayjs().startOf('month')
  const [month, setMonth] = useState(fnDateEn(toDay).format('YYYY-MM-DD'))

  useEffect(() => {
    const param = {
      page: 1,
      size: totalLimits,
      orgId: roleId,
      dateQuery: month
    }

    if (roleId) {
      getEmps(param)
    }
  }, [roleId, month])

  const getEmps = async (body) => {
    setPage(body.page)
    const data = await getReportBirthdayAPI(body)
    setIsLoading(false)
    if (!data) return
    if (data.status) {
      setDataEmps(data.result)
      setTotalRows(data.totalRows)
      setTotalLimits(data.totalLimits)
    } else {
      Error_false(data)
      setTotalRows(0)
      setTotalLimits(20)
    }
  }

  const createEmpsExcelLog2 = async (typeId) => {
    const data = await getEmpsExcelLog2API({ typeId: typeId })
    setIsLoading(false)
    if (!data) return
  }

  const checkDataExport = async () => {
    setIsExport(true)
    const param = {
      page: 1,
      orgId: roleId,
      dateQuery: month
    }
    try {
      const data = await getReportBirthdayAPI(param)
      if (!data) return
      if (data.status) {
        let excel =
          data.result.length > 0
            ? data.result.map((d, i) => {
                return {
                  num: i + 1,
                  org: d?.org ?? '-',
                  code: d?.code ?? '-',
                  level: d?.level_id ?? '-',
                  date: d.birthday
                    ? fnDateEn(d.birthday).format('DD/MM/YYYY')
                    : '-',
                  nameEn: `${d?.name_en ?? '-'}`,
                  surnameEn: d?.surname_en ?? '-',
                  nicknameEn: d?.nickname_en ?? '-',
                  nameTh: `${d?.name_th ?? '-'}`,
                  surnameTh: d?.surname_th ?? '-',
                  nicknameTh: d?.nickname_th ?? '-',
                  division: d?.division ?? '-',
                  department: d?.department ?? '-',
                  type: d?.type ?? '-'
                }
              })
            : []

        await exportExcel(excel, 'Birthdays')
      }
    } catch (error) {
      SwalCustom({
        title: 'Export failed',
        text: 'Unable to create the spreadsheet.',
        icon: 'error',
        showConfirmButton: false,
        timer: 2000
      })
    } finally {
      setIsExport(false)
    }
  }

  const exportExcel = async (dataExcel, name) => {
    const { sheetData, sheetOptions } = buildBirthdayReportSheet({
      data: dataExcel,
      organization: dataEmps?.[0]?.org_en,
      periodLabel: month ? fnDateTh(month).format('MMMM') : '-'
    })

    const blob = await createSpreadsheetBlob(sheetData, sheetOptions)

    saveAs(blob, `${name}.xlsx`)
    await createEmpsExcelLog2(7)
    SwalCustom({
      title: 'Success!',
      text: 'Exported',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500
    })
  }

  const handleDatePickerChange = (date, dateString) => {
    setMonth(dateString ? fnDateEn(date).format('YYYY-MM-DD') : '')
  }
  return (
    <>
      <Row>
        <NavTitle>
          <TextNavTitle>Birthday</TextNavTitle>
        </NavTitle>
        <div className="d-flex justify-content-between">
          <NavRoleOrg />
        </div>

        <Col xl={12}>
          <CardCustom border="0" className="h-full">
            <div className="p-3 row">
              <div className="col-5">
                <div className="col-5">
                  <label
                    className=" fw-bold me-3"
                    style={{
                      fontSize: '14px'
                    }}
                  >
                    Total: {totalRows?.toLocaleString()}
                  </label>
                </div>
                {/* <h4 className="text-muted mb-0" style={{ float: 'left' }}>
                  Birthday
                </h4> */}
              </div>
              {roleId ? (
                <div className=" d-flex justify-content-end col-7 gap-2">
                  {/* <Form.Group className="" style={{ minWidth: 300 }}>
                  <InputGroup className="">
                    <InputGroup.Text className="bg-white border-end-0  text-muted">
                      <BsSearch />
                    </InputGroup.Text>
                    <Form.Control
                      placeholder="Code/ Name/ Nickname"
                      onChange={(e) => setSearch(e.target.value)}
                      className="border-start-0 ps-0 placeholder-text"
                    />
                  </InputGroup>
                </Form.Group> */}

                  <DatePicker
                    allowClear={false}
                    style={{ minWidth: '100px' }}
                    value={month ? dayjs(month) : ''}
                    className=""
                    onChange={handleDatePickerChange}
                    format={dateFormat}
                    picker="month"
                  />
                  <Button
                    size="sm"
                    disabled={isExport}
                    className="px-3"
                    onClick={!isExport ? checkDataExport : () => {}}
                  >
                    <Image src={excelImg} style={{ width: '15px' }}></Image>
                  </Button>
                </div>
              ) : (
                <></>
              )}
            </div>
            <Table hover>
              <thead
                className="bg-hrms text-white"
                style={{ position: 'sticky', top: '0px' }}
              >
                <tr className="fw-normal font-title-table">
                  <th className="fw-normal">#</th>
                  <th className="text-center fw-normal">Image</th>

                  <th className="fw-normal">Code</th>
                  <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
                    Birth of Date
                  </th>
                  <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
                    Name
                  </th>
                  <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
                    Nickname
                  </th>
                  <th
                    className="fw-normal text-center"
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    Group {/* สายงาน */}
                  </th>
                  {/* <th className="">
             Department 
              </th> */}
                  <th className="fw-normal text-center">
                    Department {/* แผนก */}
                  </th>

                  <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
                    Position{/* ตำแหน่ง */}
                  </th>
                  <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
                    Email/ Phone No.
                  </th>
                  {/* <th className="">ทีม</th> */}
                  <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
                    Type
                  </th>
                </tr>
              </thead>
              <tbody>
                {dataEmps.length > 0 ? (
                  dataEmps.map((d, i) => (
                    <tr className="mb-3 fw-light font-small-2" key={i}>
                      <td>{page * totalLimits - totalLimits + i + 1}</td>
                      <td lg={1} className="text-center">
                        <Image
                          fluid
                          className="rounded-circle "
                          style={{
                            maxWidth: 40,
                            maxHeight: 40,
                            objectFit: 'cover'
                          }}
                          //src={`${URL_PROFILE}/${d?.folder_img}/${d?.code}_cr.jpg`}
                          src={`${d?.img_url}`}
                          onError={(event) => {
                            event.target.src = ImgUser
                            event.onerror = null
                          }}
                        />
                      </td>
                      <td>
                        <p className="font-small-2">{d.code}</p>
                      </td>
                      <td lg={1} className="c">
                        <p className="mb-1  font-small-2">
                          {' '}
                          {fnDateEn(d.birthday).format('DD/MM/YYYY')}
                        </p>
                      </td>
                      <td lg={2} className="my-auto ">
                        <p className="mb-0  font-small-2 ">
                          <span className="me-1">
                            {d.title_th}
                            {d.name_th}
                          </span>{' '}
                          <span>{d.surname_th}</span>
                        </p>
                        {/* <p className="mb-0  font-small-2 ">
                    <span className="me-1">{d.name_en}</span>{' '}
                    <span>{d.surname_en}</span>
                  </p> */}
                      </td>
                      <td lg={1} className="my-auto">
                        <p className="mb-1  font-small-2">
                          {' '}
                          {/* {d.title_th} */}
                          {d.nickname_th}
                        </p>
                        {/* <p className="mb-0  font-small-2">
                    {d.nickname_en}
                  </p> */}
                      </td>
                      <td lg={1} className="my-auto text-center">
                        <p className="mb-1  font-small-2"> {d.division}</p>
                      </td>
                      {/* <td lg={1} className="my-auto text-center">
                  <p className="mb-1  font-small-2"> {d.faction}</p>
                </td> */}
                      <td lg={1} className="my-auto text-center">
                        <p className="mb-1  font-small-2"> {d.department}</p>
                      </td>

                      <td lg={2} className="my-auto">
                        <p className="mb-1  font-small-2"> {d.position_th}</p>
                        {/* <p className="mb-0  font-small-2">
                    {d.position_en}
                  </p> */}
                      </td>
                      <td lg={2} className="my-auto">
                        <p className="mb-1  font-small-2"> {d.email}</p>
                        <p className="mb-0  font-small-2">{d.phone}</p>
                      </td>
                      {/* <td lg={2} className="my-auto">
                  <p className="mb-1  font-small-2"> {d.team_th}</p>
                  <p className="mb-0  font-small-2">{d.team_en}</p>
                </td> */}
                      <td lg={1} className="my-auto">
                        <p className="mb-1  font-small-2"> {d.type}</p>
                      </td>
                    </tr>
                  ))
                ) : !roleId ? (
                  <tr className="mb-0">
                    <td className="text-center small" colSpan={13}>
                      - ไม่พบ ORG ของท่านในระบบ โปรดติดต่อแผนก IT -
                    </td>
                  </tr>
                ) : isLoading ? (
                  <tr className="mb-0">
                    <td className="text-center" colSpan={13}>
                      <SpinnerLoading />
                    </td>
                  </tr>
                ) : (
                  <tr className="mb-0">
                    <td className="text-center" colSpan={13}>
                      -ไม่มีข้อมูล-
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <div className="pt-3">
              <PaginationControl
                page={page}
                total={totalRows}
                limit={totalLimits}
                changePage={(p) => {
                  setPage(p)
                  const body = {
                    page: p,
                    size: totalLimits,
                    orgId: roleId,
                    dateQuery: month
                  }
                  getEmps(body)
                }}
                ellipsis={1}
              />
            </div>{' '}
          </CardCustom>
        </Col>
      </Row>
    </>
  )
}

export default ReportBirthdayPage
